module.exports = {
    ACTIVITY_ROUTE: '/bianka/api/v1/activity',
    METRIC: {
        ACTIVITY: 'activity'
    },
    ERRORS: {
        REPORT_ACTIVITY_SERVER_FAILED: 'Report activity failed on server',
        REPORT_ACTIVITY_CLIENT_FAILED: 'Report activity failed on client',
        REPORT_BUSINESS_SERVER_FAILED: 'Report business failed on server',
        REPORT_BUSINESS_CLIENT_FAILED: 'Report business failed on client'
    }
};
